var _a;
import { createSlice } from '@reduxjs/toolkit';
import { sliceName } from '../../../constants';
import { carpoolInitialState } from '../../initialStates';
var carpoolSlice = createSlice({
    name: sliceName.carpoolSliceName,
    initialState: carpoolInitialState.initialCarpoolState,
    reducers: {
        setCarpool: function (state, action) {
            state.licensePlate = action.payload.licensePlate;
            state.groupId = action.payload.groupId;
            state.groupOwnerAlias = action.payload.groupOwnerAlias;
            state.id = action.payload.id;
            state.carpoolMembers = action.payload.carpoolMembers;
            state.carpoolPolicyChecked = action.payload.carpoolPolicyChecked;
        },
        resetCarpool: function (state, action) {
            state.licensePlate = action.payload.licensePlate;
            state.groupId = action.payload.groupId;
            state.groupOwnerAlias = action.payload.groupOwnerAlias;
            state.id = action.payload.id;
            state.carpoolMembers = action.payload.carpoolMembers;
            state.carpoolPolicyChecked = action.payload.carpoolPolicyChecked;
        },
        setCarpoolMemberDetail: function (state, action) {
            var _a = action.payload, formName = _a.formName, formValue = _a.formValue, index = _a.index;
            state.carpoolMembers[index][formName] = formValue;
        },
    },
});
export var setCarpool = (_a = carpoolSlice.actions, _a.setCarpool), resetCarpool = _a.resetCarpool, setCarpoolMemberDetail = _a.setCarpoolMemberDetail;
export var carpoolReducer = carpoolSlice.reducer;
